export enum CurrentViewPointerType {
    FIRST = "FIRST",
    SECOND = "SECOND",
    THIRD = "THIRD"
}